<template>
  <RemotePaginatedList :headers="headers"
                       multi-sort
                       data-url="aafb/gym_subscription/"
                       data-key="subscriptions"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.reference_number="{value}">
      {{ "GYM" + value.toString().padStart(8, '0') }}
    </template>
    <template v-slot:item.create_at="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
    </template>
    <template v-slot:item.valid_until="{value}">
      {{ value ? parsePassValidUntil(value) : '' }}
    </template>
    <template v-slot:item.status="{item}">
      {{ $t(BOOKING_STATUS_LABEL[item.status]) }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-btn icon color="primary"
             @click="viewSubscription(item)">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon color="primary"
             :to="{name: 'gym-pass-preview', params: {subscriptionId: item.id}}"
             v-if="item.status === 0">
        <v-icon>mdi-cash-register</v-icon>
      </v-btn>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from "@vue/composition-api";
import {BOOKING_STATUS_LABEL} from "@/constants";
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {DateTime} from "luxon";

export default {
  name: 'GymSubscriptionList',
  components: {RemotePaginatedList},
  props: {
    userId: String,
  },
  setup(props, {root, emit}) {
    const innerRefreshTrigger = ref(false);
    const refresh = async function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Data Table
    const headers = ref([
      {text: root.$t('gym_booking.reference_number'), value: 'reference_number'},
      {text: root.$t('admin_acc_booking.datetime'), value: 'create_at'},
      {text: root.$t('gym_subscription.type'), value: 'type.name'},
      {text: root.$t('gym_subscription.status'), value: 'status'},
      {text: root.$t('gym_subscription.valid_until'), value: 'valid_until'},
      {text: '', value: 'actions'},
    ]);

    const parsePassValidUntil = function(d) {
      return DateTime.fromISO(d).minus({'seconds': 1}).toFormat('yyyy-MM-dd HH:mm');
    }

    const viewSubscription = function (item) {
      root.$router.push({name: 'gym-pass-detail', params: {subscriptionId: item.id}});
    };

    return {
      innerRefreshTrigger,

      headers,

      parsePassValidUntil,

      viewSubscription,

      BOOKING_STATUS_LABEL,
    }
  },
}
</script>

<style lang="less">
.b-table-empty-row {
  color: #444;
  font-size: 2rem;
}

</style>
